import React from "react";
import { Star, ShieldCheck } from "lucide-react";
import { Marquee } from "./effects/Marquee";

interface Testimonial {
  name: string;
  location: string;
  text: string;
  rating: number;
  badge: string;
}

const TESTIMONIALS: Testimonial[] = [
  { name: "Juan P.", location: "Medellín", text: "El contenido está brutal mor, 100% recomendado el VIP 🔥", rating: 5, badge: "Miembro VIP" },
  { name: "Carlos M.", location: "Bogotá", text: "Impresionante la calidad de los videos y la atención al privado.", rating: 5, badge: "Miembro Activo" },
  { name: "David R.", location: "Cali", text: "Valió totalmente la pena la suscripción anual, puro contenido top.", rating: 5, badge: "VIP Anual" },
  { name: "Mateo S.", location: "México", text: "Pagué por PayPal desde México sin problemas. Muy melo todo mor 😏", rating: 5, badge: "Internacional" },
];

export const TestimonialsSection: React.FC = () => {
  return (
    <div className="w-full py-6 space-y-3">
      <div className="flex items-center gap-2 px-4">
        <ShieldCheck className="w-5 h-5 text-emerald-400" />
        <h2 className="text-lg font-bold text-white tracking-wide">Comunidad VIP Opiniones</h2>
      </div>

      <Marquee pauseOnHover className="[--duration:25s]">
        {TESTIMONIALS.map((item, idx) => (
          <div
            key={idx}
            className="w-64 p-4 rounded-xl bg-neutral-900/80 border border-neutral-800 backdrop-blur-sm space-y-2 mx-2 flex-shrink-0"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-gradient-to-tr from-rose-600 to-purple-600 flex items-center justify-center font-bold text-white text-xs shadow-inner">
                  {item.name[0]}
                </div>
                <div>
                  <h4 className="text-xs font-semibold text-white">{item.name}</h4>
                  <span className="text-[10px] text-neutral-400">{item.location}</span>
                </div>
              </div>
              <span className="text-[9px] px-1.5 py-0.5 rounded bg-rose-500/10 text-rose-400 border border-rose-500/20">
                {item.badge}
              </span>
            </div>

            <p className="text-xs text-neutral-300 italic leading-relaxed">"{item.text}"</p>

            <div className="flex items-center gap-0.5 text-amber-400 pt-1">
              {[...Array(item.rating)].map((_, i) => (
                <Star key={i} className="w-3 h-3 fill-amber-400 text-amber-400" />
              ))}
            </div>
          </div>
        ))}
      </Marquee>
    </div>
  );
};
